import React, { useState, useEffect } from 'react';
import AccountingSystemTypeDropDown from '../../shared/AccountingSystemTypeDropDown';
import GridSearchTemplate from '../../../pages/GridSearchTemplate'
import { useTextResources, useMessageResources } from '../../../language';
import { DatePicker } from '../../shared/DatePicker';
import { Button, Form } from 'semantic-ui-react';
import { AccountingSystem } from '../../../api/services/next';
import moment from 'moment'
import _ from 'lodash'
import { IconButton } from '@material-ui/core';
import { GetApp, } from '@material-ui/icons';
import { GetReport } from '../../../api/services/finance';
import multiDownload from 'multi-download';
import { onWarning, onError, onSuccess } from '../../shared/messages';
import { useLoader } from '../../shared/utils';
import { dateFormat, dateTimeFormat } from '../../shared/constants';
import CheckboxWrapper from '../../shared/Checkbox';

const AccountingSystemReport = () => {
    const loader = useLoader()
    const text = useTextResources()
    const path = "c:\\AccountingSystem"
    const message = useMessageResources()
    const [data, setData] = useState([])
    const hotelId = window.optima?.user?.CurrentHotel?.Id || window.user?.CurrentHotel?.Id
    const mainCurrencyId = window.optima?.user?.CurrentHotel?.MainCurrencyId || window.user?.CurrentHotel?.MainCurrencyId
    const [spec, setSpec] = useState([])
    const [isCreateNewFile, setIsCrateNewFile] = useState(false);
    const [exportType, setExportType] = useState([])


    useEffect(() => {
        (async () => {
            try {
                const data = await AccountingSystem.GetAccountingSystemTypes({ IsActive: true, HotelId: hotelId });
                setExportType([...data, ...[{ "Id": 100, "Name": "PCN Report" }]])
            } catch (error) {
                onError(error);
            }
        })();

    }, []);


    const onUpdate = (added, changed, deleted, data) => {
        setData(data)
    }
    const dateFormatter = ({ value }) => {
        return value && moment(value).format(dateTimeFormat)
    }
    const customizeExcelHeader = worksheet => {
        const row = worksheet.addRow([`${text("AccountingSystemReport")} :  ${moment(spec.FromDate).format(dateFormat)} - ${moment(spec.ToDate).format(dateFormat)} `])
        worksheet.mergeCells('A1:O1');
        row.height = 30
        row.font = { bold: true, size: 20 };
    }
    const createNewFileClick = () => {
        var valid = validateSpec(spec);
        if (!spec.Id) {
            valid = false;
            onWarning(message("AccountingSystemTypeIsMandatoryField"))
        }
        if (valid) {
            (async () => {
                loader(true)
                try {
                    var data = [];
                    if (spec.Id == 100) {
                        setIsCrateNewFile(false);
                        data = await AccountingSystem.PostPCNReport({ HotelId: hotelId, ..._.omit(spec, "IncludeAllocationNumberData") })
                    }
                    else {
                        setIsCrateNewFile(true);
                        data = await GetReport(
                            {
                                HotelId: hotelId,
                                EndDate: spec.ToDate,
                                StartDate: spec.FromDate,
                                AccountingSystemTypeID: spec.Id,
                                MainCurrencyId: mainCurrencyId,
                                PathFile: path,
                                ReturnOnlyLastRunData: true,
                                IncludeAllocationNumberData: spec.IncludeAllocationNumberData
                            })

                    }
                    setData(data)
                    onSuccess()
                } catch (error) {
                    onError(error)
                }
                finally {
                    loader(false)
                }
            })()
        }
    };

    const downloadFileClick = ({ value, row }) => {
        return <IconButton size='medium' onClick={() => {
            const urls = row?.FileName?.split(",").map(file => value + file)
            multiDownload(urls);
        }
        }>
            <GetApp />
        </IconButton>
    }

    const validateSpec = spec => {
        if (!spec.FromDate) {
            onWarning(message("FromDateIsRequired"))
            return false
        }
        if (!spec.ToDate) {
            onWarning(message("ToDateIsRequired"))
            return false
        }

        return true
    }

    const onSearchComplete = async (data) => {
        setIsCrateNewFile(false);
        setData(data)
    }

    const gridOptions = {
        search: {
            title: text("AccountingSystemReport"),
            fields: [
                <Form.Field control={AccountingSystemTypeDropDown} name="Type" clearable label={text("ExportAccountingData")} key="Id" data={exportType} />,
                <DatePicker
                    type="basic"
                    label={`${text("FromDate")}`}
                    name="FromDate"
                    key="FromDate"
                />,
                <DatePicker
                    type="basic"
                    label={`${text("ToDate")}`}
                    name="ToDate"
                    key="ToDate"
                />,
                spec.Id !== 100 && <CheckboxWrapper
                    label={text("IncludeAllocationNumber")}
                    key="IncludeAllocationNumberData"
                />,

            ].filter(Boolean),
            buttons: [
                <Button key="addFile" onClick={createNewFileClick}>{text("CreateNewFile")}</Button>
            ],
            api: AccountingSystem.GetOpenFormatLog,
            spec: {
                HotelId: hotelId
            },
            validate: validateSpec,
            searchOnLoad: false
        },
        grid: {
            columns: [
                { name: isCreateNewFile ? 'HotelID' : 'HotelId', title: text("Hotel") },
                { name: 'CreateDate', title: text("CreateDate"), formatter: dateFormatter },
                { name: 'FileName', title: text("FileNames"), width: 5, },
                { name: 'FullFilePath', title: text("DownloadFiles"), formatter: downloadFileClick, },
            ],

            export: true,
            excel: {
                customizeHeader: customizeExcelHeader,
            },
            paging: true,
        }
    }
    return (<GridSearchTemplate options={gridOptions} onGridUpdate={onUpdate} onSearchChange={setSpec} onSearchComplete={onSearchComplete} data={data} />)
}
export default AccountingSystemReport